import { constants } from './constants';
import { filterDateStringsKeys } from './types';
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory("filter-data-search");

export const SetFilterStartDateAction = actionCreator<{ id: filterDateStringsKeys, input: Date }>(constants.SET_FILTER_START_DATE);
export const SetFilterEndDateAction = actionCreator<{ id: filterDateStringsKeys, input: Date }>(constants.SET_FILTER_END_DATE);
export const SetFilterHomeLocation = actionCreator<{ id: filterDateStringsKeys, input: boolean }>(constants.SET_FILTER_HOME_LOCATION);